import axios from "axios"

class UserNavigationAPI {
  getUserNavigation = async () => {
    return axios.get(`api/user-navigation`)
  }
}

export const userNavigation = new UserNavigationAPI()
